import { render, staticRenderFns } from "./vehicle-list.vue?vue&type=template&id=a10cc85e&scoped=true"
import script from "./vehicle-list.vue?vue&type=script&lang=js"
export * from "./vehicle-list.vue?vue&type=script&lang=js"
import style0 from "./vehicle-list.vue?vue&type=style&index=0&id=a10cc85e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10cc85e",
  null
  
)

export default component.exports